import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ContactPopup from "./ContactPopup"; 
import BlurText from '../customComponent/BlurText';


const HeroSection = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 3000);
 
    return () => clearTimeout(timer);
  }, []);

  const handleClosePopup = () => setShowPopup(false);

  return (
    <section className="relative h-screen w-full overflow-hidden px-4">
      {/* Background Video */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/hero-bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="flex flex-col justify-center items-center h-full text-center mt-16 relative z-10">
        <div className="bg-black bg-opacity-50 p-10 rounded-2xl max-w-4xl">
          <BlurText
            text="Comprehensive Business Solutions for Modern Enterprises"
            className="text-white text-3xl md:text-5xl font-bold leading-10"
            animateBy="words"
            delay={250}
          />
          <p className="text-gray-200 mt-4 text-sm md:text-base">
            We provide AI-powered solutions along with expert services in different domains.
          </p>
          <Link to="/glowtech-services">
            <button
              className="mt-6 px-6 py-2 bg-white text-blue-700 font-semibold rounded-full hover:bg-blue-100 transition"
            >
              Explore More
            </button>
          </Link>
        </div>
      </div>

      {showPopup && <ContactPopup onClose={handleClosePopup} />}
    </section>
  );
};

export default HeroSection;
